module.exports = "https://cdn-skillquest.mathletics.com/app/170/assets/images/d44613c346242d393e68b1d272a024b8.svg";